// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"OrderNav_clearfix_10f-B"};